module.exports = __webpack_public_path__ + "static/media/grazie.872d882b.svg";